"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var date_fns_1 = require("date-fns");

var DayPickerInput_1 = require("react-day-picker/DayPickerInput");

var DateInputNavbar_1 = require("./DateInputNavbar");

var DateInputOverlay_1 = require("./DateInputOverlay");

var styles_1 = require("./styles");

var font_1 = require("@headspace/hs-web-style-guide/dist/font");

var formatDate = date_fns_1.format;

exports.DateInput = function (_a) {
  var hasError = _a.hasError,
      disabled = _a.disabled,
      customInputStyles = _a.customInputStyles,
      passedProps = __rest(_a, ["hasError", "disabled", "customInputStyles"]);

  var id = passedProps.id,
      value = passedProps.value,
      onChange = passedProps.onChange,
      _b = passedProps.format,
      format = _b === void 0 ? 'MM/DD/YYYY' : _b;
  return React.createElement(DayPickerInput_1.default, {
    formatDate: formatDate,
    format: format,
    placeholder: format,
    parseDate: function parseDate(input) {
      if (Date.parse(input)) {
        return date_fns_1.parse(input);
      }

      return date_fns_1.parse(new Date());
    },
    overlayComponent: DateInputOverlay_1.DateInputOverlay,
    value: value ? value : '',
    onDayChange: function onDayChange(day, modifiers, input) {
      var inputDay = input.getInput().value.length && input.getInput().value;
      var thisDay = inputDay || day;

      if (thisDay) {
        onChange({
          target: {
            id: id,
            value: thisDay
          }
        });
      }
    },
    inputProps: Object.assign({
      id: name,
      readOnly: false
    }, __assign({}, passedProps), __assign({}, font_1.p4), __assign({}, styles_1.inputStyles(hasError)), __assign({}, styles_1.inputOptions(customInputStyles))),
    dayPickerProps: {
      showOutsideDays: true,
      navbarElement: React.createElement(DateInputNavbar_1.DateInputNavBar, null),
      captionElement: function captionElement(_a) {
        return React.createElement("span", null);
      },
      weekdaysShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
    }
  });
};